import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface Incoterm {
  id: number;
  name: string;
}

export const useIncoterms = () => {
  const [incoterms, setIncoterms] = useState<Incoterm[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchIncoterms = async () => {
      try {
        const { data, error } = await supabase
          .from('bookings_incoterm')
          .select('id, name')
          .order('name');

        if (error) throw error;
        setIncoterms(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch incoterms');
      } finally {
        setLoading(false);
      }
    };

    fetchIncoterms();
  }, []);

  return { incoterms, loading, error };
}; 